var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResolve(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "77px",
    viewBox: "0 0 59 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "33E299F1-0FDF-44B9-8458-85692D8B82A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Secondary-Navigation-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Support-Select-Copy",
    transform: "translate(-144.000000, -1229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mic-+-Cam-Detection",
    transform: "translate(142.000000, 1229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5161862,59.4971133 L29.3955936,45.487552 L4.27500096,59.4971133 C1.85955936,60.7853488 0.4102944,63.2007904 0.4102944,65.9382909 L0.4102944,73.1530413 C0.4102944,74.7633357 1.69852992,76.0515712 3.30882432,76.0515712 L55.4823629,76.0515712 C57.0926573,76.0515712 58.3808928,74.7633357 58.3808928,73.1530413 L58.3808928,65.9382909 C58.3808928,63.2007904 56.9316278,60.7853488 54.5161862,59.4971133 Z",
    id: "Path",
    fill: "#D1DAE4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF5756",
    fillRule: "nonzero",
    cx: 29.3955936,
    cy: 29.3955936,
    r: 28.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3955936,58.1955936 C45.3013944,58.1955936 58.1955936,45.3013944 58.1955936,29.3955936 C52.4,28.4 10.8,30 0.5955936,29.3955936 C0.5955936,45.3013944 13.4897928,58.1955936 29.3955936,58.1955936 Z",
    id: "Oval",
    fill: "#FF5756",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.9955936,
    y1: 29.3955936,
    x2: 3.7955936,
    y2: 29.3955936,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 6.4411776,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 29.3955936,
    cy: 29.3955936,
    r: 17.7132384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3698576,19.8948566 L25.3698576,19.8948566 C29.3955936,18.1235328 34.3875062,19.0897094 37.4470656,22.954416 C39.3794189,25.2088282 40.0235366,28.429417 39.5404483,31.3279469 C38.2522128,38.2522128 30.8448586,41.4728016 25.0477987,38.7353011 C19.8948566,36.3198595 17.8014739,30.0397114 20.2169155,25.0477987 L20.2169155,25.0477987 C23.2764749,26.0139754 26.3360342,23.1154454 25.3698576,19.8948566 Z",
    id: "Path",
    fill: "#000F38",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolve);
export default __webpack_public_path__ + "static/media/resolve.d9ca76a56e81de8f77ca66aaed9e9f2f.svg";
export { ForwardRef as ReactComponent };